namespace TabAurous.Finance {
    export interface AccountingPeriodRow {
        PeriodId?: number;
        Code?: string;
        FromDate?: string;
        ToDate?: string;
        CompanyId?: number;
        Details?: AccountingPeriodDetailsRow[];
    }

    export namespace AccountingPeriodRow {
        export const idProperty = 'PeriodId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Finance.AccountingPeriod';
        export const deletePermission = 'Finance:AccountingPeriod:Delete';
        export const insertPermission = 'Finance:AccountingPeriod:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:AccountingPeriod:Edit';

        export declare const enum Fields {
            PeriodId = "PeriodId",
            Code = "Code",
            FromDate = "FromDate",
            ToDate = "ToDate",
            CompanyId = "CompanyId",
            Details = "Details"
        }
    }
}
